<kl-form-container
  mode="edit"
  [saveHidden]="true"
  [saveAndNew]="false"
  [loading]="loading()"
  loadingText="loading"
  [alertShow]="alertShow()"
  [alertMessage]="alertMessage()"
  alertType="error"
  [buttons]="toolbarButtons"
  (closeAlert)="alertShow.set(false)">
  <p-table
    [value]="designList()"
    selectionMode="single"
    [(selection)]="selectedDesign"
    [scrollable]="true"
    scrollHeight="300px"
    dataKey="id">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'description' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-design>
      <tr [pSelectableRow]="design">
        <td>{{ design.description }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td>{{ 'no_data' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>

  <div class="dialog-footer">
    <p-button
      [label]="'print' | translate"
      icon="ph ph-printer"
      severity="primary"
      size="small"
      [disabled]="!selectedDesign"
      (onClick)="print()" />
    <p-button [label]="'close' | translate" severity="secondary" [outlined]="true" size="small" (onClick)="close()" />
  </div>
</kl-form-container>
